import CreateInvestmentError from './CreateInvestmentError';
class CheckoutError extends CreateInvestmentError {
    constructor(options) {
        super('Unexpected error while trying to checkout', options);
    }
}
export default CheckoutError;
